<script>
    import LogItem from './LogItem.svelte';
    import { afterUpdate, onMount, tick } from 'svelte';
    import { state as _state } from './stores.js';
    import { cardByID } from './game';
    import { hasLogText } from './ui.js';
    import { perfCount, perfMeasure } from './perf.js';

    export let log;
    export let showCaptain = true;
    export let showTitle = true;
    export let autoScroll = false;
    export let logElement;
    export let state = $_state;
    export let onlyLatest = false;

    let groupedLog = [];
    let currentGroup = null;

    let filter = '';
    let visibleGroups = [];

    
    
    /*onMount(() => tick().then(() => scrollToBottom('instant')));
    afterUpdate(() => {
        scrollToBottom('instant');
    })*/

    const scrollToBottom = (behavior = 'instant') => {
        if(!logElement) return;
        console.log('scrolling to bottom', logElement, behavior);
        logElement.scroll({ top: logElement.scrollHeight, behavior });
    }; 

    afterUpdate(() => perfCount('render.Log.afterUpdate'));

    $: if(log){
        perfMeasure('render.Log.groupLog', () => {
            groupedLog = [];
            currentGroup = false;
            for(let l of log){
                //console.log(l);
                if(!l) continue;
                if(l.event == 'playerTurn'){
                    currentGroup = {
                        player: l.player,
                        log: [ l ]
                    }
                    groupedLog.push(currentGroup);
                }else if(currentGroup && currentGroup.log){
                    currentGroup.log.push(l);
                }else{
                    //console.log('Error: malformed log!')
                    // Starter actions, I guess
                    currentGroup = {
                        player: l.player || 0,
                        log: [ l ]
                    }
                    groupedLog.push(currentGroup);
                }
            }
            tick().then(() => scrollToBottom());
        }, {entries: log.length});
        }

    function getLogCardName(s){
        if(!s || !s.startsWith('|')) return '';
        let token = s;
        if(token.startsWith('|h') || token.startsWith('|v')){
            token = `|${token.slice(2)}`;
        }
        let id = token.slice(1, token.length - 1);
        if(id.includes(',')){
            id = id.split(',')[1];
        }
        let c = cardByID(id);
        return c && c.name ? c.name : id;
    }

    function getSearchText(value){
        if(!value) return '';
        if(typeof value == 'string'){
            return value.split('$').map(s => `${s} ${getLogCardName(s)}`).join(' ');
        }
        if(Array.isArray(value)) return value.map(getSearchText).join(' ');
        if(typeof value == 'object') return Object.values(value).map(getSearchText).join(' ');
        return String(value);
    }

    function groupMatches(g, filter){
        let normalized = filter.trim().toLowerCase();
        if(!normalized) return true;
        let player = state.players[g.player];
        let haystack = [
            player && player.captain,
            getSearchText(g.log)
        ].join(' ').toLowerCase();
        return haystack.includes(normalized);
    }

    // An entry whose action hasn't produced text (yet) renders as nothing, so
    // don't draw the separators around it.
    function visibleElements(l){
        if(!l || !l.elements) return [];
        return l.elements.filter(le => hasLogText(le));
    }

    $: visibleGroups = groupedLog.filter(g => groupMatches(g, filter));

    $: console.log(log);

</script>

{#if showTitle}<h2>Game log</h2>
<div class="log_tools">
    <label>
        Search
        <input type="search" bind:value={filter} placeholder="Card, action, captain..." />
    </label>
    {#if filter}
        <button on:click={() => filter = ''}>Clear</button>
    {/if}
</div>
{/if}
<div bind:this={logElement} class="log_holder">
    <button on:click={e => {scrollToBottom('smooth')}}>Jump to end</button>
    {#if visibleGroups.length == 0}
        <div class="empty_log">No log entries match "{filter}".</div>
    {/if}
    {#each visibleGroups as g, i}
        {#if !onlyLatest || i == visibleGroups.length - 1}
            <div class="turn player_{g.player}">
                {#each g.log as l, j}
                    {@const elements = visibleElements(l)}
                    {#if hasLogText(l) || elements.length > 0}
                        <div class={l && l.elements ? 'dotted_'+g.player : ''}>
                            <LogItem showCaptain log={l} />
                            {#if elements.length > 0}
                                : {#each elements as le}
                                    <LogItem showCaptain={typeof le.p == 'number' && typeof l.p == 'number' && state.players[l.p] && state.players[le.p] && state.players[l.p].captain != state.players[le.p].captain} log={le} />.
                                {/each}
                            {/if}
                        </div>
                    {/if}
                {/each}
            </div>
        {/if}
    {/each}
</div>
<style>
    .log_holder {
        overflow-y: auto;
        max-height: 60vh;
    }

    .log_tools {
        display: flex;
        align-items: center;
        gap: 1vmin;
        flex-wrap: wrap;
        margin-bottom: 1vmin;
    }

    .log_tools input {
        font-size: 1em;
        max-width: 60vw;
    }

    .empty_log {
        margin: 1vmin;
        font-style: italic;
    }

    .turn {
        margin: 1vmin;
        padding: 1vmin;
    }

    .player_0 {
        color: white;
        background-color: black;
        border: 1vmin solid white;
    }

    .player_1 {
        color: black;
        background-color: white;
        border: 1vmin solid black;
    }

    .dotted_0 {
        border-bottom: 1px dashed white;
    }

    .dotted_1 {
        border-bottom: 1px dashed black;
    }
</style>
